module.exports = __webpack_public_path__ + "static/media/logo-murilo.a33bd575.png";